import {type HTMLAttributes, type ReactNode, useLayoutEffect, useRef, useState} from 'react';

type Props = Omit<HTMLAttributes<HTMLDivElement>, 'children'> & {
    children: (width: number, height: number) => ReactNode;
};

export const ResizeObserverComponent = ({children, ...props}: Props) => {
    const [height, setHeight] = useState<number>(0);
    const [width, setWidth] = useState<number>(0);
    const contentDiv = useRef<HTMLDivElement>(null);

    useLayoutEffect(() => {
        const element = contentDiv.current;

        if (!element) {
            return;
        }

        setHeight(element.clientHeight);
        setWidth(element.clientWidth);

        const resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
            for (const entry of entries) {
                if (entry.target === contentDiv.current) {
                    setHeight(element.clientHeight);
                    setWidth(element.clientWidth);
                }
            }
        });

        resizeObserver.observe(element);

        return () => resizeObserver.disconnect();
    }, []);

    return (
        <div ref={contentDiv} {...props}>
            {children(width, height)}
        </div>
    );
};
